import axios from 'axios';

export default {
  state: {
    bonus: {},
    bonusError: null,
    bonusLoaded: false,
    bonusLoading: false,
  },
  mutations: {
    SET_BONUS(state, bonus) {
      state.bonus = bonus;
      state.bonusLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_BONUS_LOADING(state, status) {
      state.bonusLoading = status;
    },
    UNSET_BONUS(state) {
      state.bonusLoaded = false;
      state.bonusLoading = false;
      state.bonus = {};
    },
    SET_BONUS_ERROR(state, error) {
      state.bonusError = error;
    }
  },
  actions: {
    async fetchBonus({ commit, state }) {
      commit('UNSET_BONUS');

      try {
        commit('SET_BONUS_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/user/bonus/');
        commit('SET_BONUS', response.data.data);
        commit('SET_BONUS_ERROR', null);
      } catch (error) {
        commit('SET_BONUS_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching bonus:', error);
      } finally {
        commit('SET_BONUS_LOADING', false);
      }
    }
  },
  getters: {
    bonus: state => state.bonus,
    bonusLoading: state => state.bonusLoading,
    bonusError: state => state.bonusError,
    bonusLoaded: state => state.bonusLoaded
  }
}